Object.defineProperty(exports, "__esModule", {
  value: true
})

var _react = require('react')

_interopRequireDefault(_react)

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj } }

var core = {
  white: '#fff',
  gray: '#565a5c',
  grayLight: '#82888a',
  grayLighter: '#cacccd',
  grayLightest: '#fafafa',

  borderMedium: '#c4c4c4',
  border: '#dbdbdb',
  borderLight: '#e4e7e7',
  borderLighter: '#eceeee',

  primary: '#338033',
  primaryShade_1: 'lighten(#338033, 5%)',
  primaryShade_2: '#ffb400',
  primaryShade_3: '#ffdec7',
  primaryShade_4: '#b2f1ec',

  secondary: '#ffdec7',

  yellow: '#ffe8bc',
  yellow_dark: '#ffce71'
}

export default {
  reactDates: {
    zIndex: 0,
    border: {
      input: {
        width: 'auto',
        border: 0,
        borderTop: 0,
        borderRight: 0,
        borderBottom: 0,
        borderLeft: 0,
        outlineFocused: 0,
        borderFocused: 0,
        borderTopFocused: 0,
        borderLeftFocused: 0,
        borderBottomFocused: 0,
        borderRightFocused: 0
      }
    },

    color: {
      core: core,
      disabled: core.grayLightest,
      background: core.white,
      backgroundDark: '#f2f2f2',
      backgroundFocused: core.white,
      text: core.gray,
      textDisabled: core.border,
      textFocused: '#007a87',
      placeholderText: '#757575',

      outside: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },

      highlighted: {
        backgroundColor: core.yellow,
        backgroundColor_active: core.yellow_dark,
        backgroundColor_hover: core.yellow_dark,
        color: core.gray,
        color_active: core.gray,
        color_hover: core.gray
      },

      minimumNights: {
        backgroundColor: core.white,
        backgroundColor_active: core.white,
        backgroundColor_hover: core.white,
        borderColor: core.borderLighter,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },

      hoveredSpan: {
        backgroundColor: core.primaryShade_4,
        backgroundColor_active: core.primaryShade_3,
        backgroundColor_hover: core.primaryShade_4,
        borderColor: core.primaryShade_3,
        borderColor_active: core.primaryShade_3,
        borderColor_hover: core.primaryShade_3,
        color: core.secondary,
        color_active: core.secondary,
        color_hover: core.secondary
      },

      selectedSpan: {
        backgroundColor: core.primaryShade_2,
        backgroundColor_active: core.primaryShade_1,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primaryShade_1,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },

      selected: {
        backgroundColor: core.primary,
        backgroundColor_active: core.primary,
        backgroundColor_hover: core.primaryShade_1,
        borderColor: core.primary,
        borderColor_active: core.primary,
        borderColor_hover: core.primary,
        color: core.white,
        color_active: core.white,
        color_hover: core.white
      },

      blocked_calendar: {
        backgroundColor: core.grayLightest,
        backgroundColor_active: core.grayLightest,
        backgroundColor_hover: core.grayLightest,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      },

      blocked_out_of_range: {
        backgroundColor: core.grayLightest,
        backgroundColor_active: core.grayLightest,
        backgroundColor_hover: core.grayLightest,
        borderColor: core.borderLight,
        borderColor_active: core.borderLight,
        borderColor_hover: core.borderLight,
        color: core.grayLighter,
        color_active: core.grayLighter,
        color_hover: core.grayLighter
      }
    },

    spacing: {
      captionPaddingTop: 22,
      captionPaddingBottom: 37,
      inputPadding: 0,
      inputMarginBottom: 60, // spacing in between the input and the picker
      displayTextPaddingVertical: 13,
      displayTextPaddingHorizontal: 14
    },

    sizing: {
      inputWidth: '100%',
      tooltipArrowWidth: 20,
      arrowWidth: 0
    },

    font: {
      size: 10,
      captionSize: 18,
      input: {
        size: 16,
        lineHeight: 1.4,
        styleDisabled: 'italic'
      }
    }
  }
}
